import { render, staticRenderFns } from "./siderBar.vue?vue&type=template&id=29cfae92&scoped=true&"
import script from "./siderBar.vue?vue&type=script&lang=js&"
export * from "./siderBar.vue?vue&type=script&lang=js&"
import style0 from "./siderBar.vue?vue&type=style&index=0&id=29cfae92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cfae92",
  null
  
)

export default component.exports